/**
 * Removes all HTML tags from a string
 * @param htmlString - The HTML string that needs to be parsed
 * @return The stripped string
 */
export function stripHTMLTagsFromString(htmlString: string) {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return (doc.body.textContent || '').trim();
}
